var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.92 6.919 12.6 8.237a.85.85 0 0 1-1.202 0L10.081 6.92a3.65 3.65 0 0 0-5.162 5.162L12 19.16l7.081-7.08.601.601-.601-.601a3.65 3.65 0 1 0-5.162-5.162m-1.203-1.202a5.35 5.35 0 1 1 7.566 7.566l-7.682 7.682a.85.85 0 0 1-1.202 0l-7.682-7.682a5.35 5.35 0 0 1 7.566-7.566l.717.717z",
  clipRule: "evenodd"
})));
export default SvgHeart;